import React from "react";
import PropTypes from "prop-types";

import WrapperContainer from "../../../../components/WrapperContainer/WrapperContainer.jsx";
import DocumentItem from "../DocumentItem/DocumentItem.jsx";

import "./style.scss";

const DocumentList = ({ unsignedDocuments, signedDocuments, contract, getDocuments, ...rest }) => {
  return (
    <>
      <WrapperContainer gap="16" title="sm">
        Подписание документов
      </WrapperContainer>
      <WrapperContainer gap="24" text="lg">
        Для активации вашего договора подпишите следующие документы:
      </WrapperContainer>

      <WrapperContainer gap="24">
        {unsignedDocuments.map((document, index) => (
          <DocumentItem
            key={index}
            isUnsignedDocument={true}
            document={document}
            contract={contract}
            getDocuments={getDocuments}
          />
        ))}
        {signedDocuments.map((document, index) => (
          <DocumentItem
            key={index}
            isUnsignedDocument={false}
            document={document}
            contract={contract}
          />
        ))}
      </WrapperContainer>

      {rest.children}
    </>
  );
};

DocumentList.propTypes = {
  unsignedDocuments: PropTypes.array.isRequired,
  signedDocuments: PropTypes.array.isRequired,
  contract: PropTypes.object.isRequired,
  getDocuments: PropTypes.func.isRequired,
};

export default DocumentList;
